import intl from 'react-intl-universal';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { MultiButtonModal } from 'shared/modals/MultiButtonModal/multiButtonModal';
import { zIndexValues } from 'utils/styles';
import { ACTIONS } from 'components/DropZone';
import logger from 'utils/logger';

const propTypes = {
  duplicatedAttachments: PropTypes.array.isRequired,
  handleDuplicateAttachments: PropTypes.func.isRequired,
  canReplace: PropTypes.bool,
};

const log = logger.createLogger('DuplicatedFileModal');

// Can be multiple modals
const DuplicatedFileModal = ({
  duplicatedAttachments,
  handleDuplicateAttachments,
  canReplace,
}) => {
  const buttons = [
    ...(canReplace
      ? [
          {
            dataTestId: 'confirm-modal-button-replace',
            variant: 'info',
            label: intl.get('new_modal_duplicate_files_replace'),
            onClick: () => handleDuplicateAttachments(ACTIONS.REPLACE),
          },
        ]
      : []),
    {
      dataTestId: 'confirm-modal-button-add',
      variant: canReplace ? 'secondary' : 'info',
      isDisabled: false,
      label: intl.get('new_modal_duplicate_files_add_as_new'),
      onClick: () => handleDuplicateAttachments(ACTIONS.ADD_AS_NEW),
    },
    {
      dataTestId: 'confirm-modal-button-cancel',
      variant: 'error',
      isDisabled: false,
      label: intl.get('new_modal_duplicate_files_ignore'),
      onClick: () => handleDuplicateAttachments(ACTIONS.IGNORE),
    },
  ];
  const children = (
    <Box data-testid="modal-child-box" sx={{ maxWidth: 'md' }}>
      {duplicatedAttachments.map((file, index) => (
        <Typography variant="h6" style={{ color: 'red' }} key={index}>
          {file.fileFullPath}
        </Typography>
      ))}
      <Typography variant="h6" style={{ paddingTop: '30px' }}>
        {intl.get('new_modal_duplicate_files_message_2')}
      </Typography>
    </Box>
  );

  return (
    <MultiButtonModal
      title={intl.get('new_modal_duplicate_files_message_1')}
      isOpened={duplicatedAttachments.length > 0}
      onClose={() => handleDuplicateAttachments(ACTIONS.CANCEL)}
      zIndex={zIndexValues.modal4}
      actionButtons={buttons}>
      {children}
    </MultiButtonModal>
  );
};

DuplicatedFileModal.propTypes = propTypes;

export default DuplicatedFileModal;
